import React, { Component } from 'react';
import { connect } from 'react-redux';
import Spinner from './../../../components/Spinner';
import SingleLineCaption from './../../../components/dom-elements/SingleLineCaption';
import LinkWrapper from './../LinkWrapper';
import VideoPlayer from './../../../components/video-player/VideoPlayer';

class MobileGridItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      itemStyle: {
        opacity: 0
      },
      bgStyle: {}
    };
  }

  handleImageLoaded() {
    this.setState({
      bgStyle: {
        backgroundImage: `url(${this.props.itemData.image.large})`
      }
    });
    setTimeout(() => {
      this.setState({
        loaded: true,
        itemStyle: {
          opacity: 1
        }
      });
    }, 250);
  }

  render() {
    return (
      <LinkWrapper
        linkData={this.props.itemData}
        linkClass={(!this.props.itemData.video && (this.props.video_header_state == 'video-playing') && true)}
        hideCaption={(!this.props.itemData.video && ((this.props.video_header_state == 'video-playing') || (this.props.video_header_state == 'video-paused')) && true)}
      >
        <div className={'hp-image-wrapper'} style={this.state.itemStyle}>
          <div className={`c-${this.props.itemData.type} hp-mobile-grid-item`} style={this.state.bgStyle}>
            {(this.props.itemData.video)
              ? <div className={'video-wrapper'}>
                  <VideoPlayer videoId={this.props.itemData.video} videoUrl={`https://vimeo.com/${this.props.itemData.video}`} videoPoster={this.props.itemData.image.large} videoCover={true} cta={'PLAY'}/>
                  <img className='hp-image__loader' src={this.props.itemData.image.large} onLoad={this.handleImageLoaded.bind(this)}/>
                </div>
              : <img className='hp-image__loader' src={this.props.itemData.image.large} onLoad={this.handleImageLoaded.bind(this)}/>
            }
          </div>
          <div className={'hp-caption-wrapper'}>
          {(this.props.itemData.linkType == 'instagram') ?
            <div onClick={(e) => { e.stopPropagation();}}>
              <SingleLineCaption Headline={this.props.itemData.title} Description={this.props.itemData.description} Stacked={true}/>
            </div>
            : <SingleLineCaption Headline={this.props.itemData.title} Description={this.props.itemData.description} Stacked={true}/>
          }
          </div>
        </div>
        {(!this.state.loaded) && <Spinner/> }
      </LinkWrapper>
    );
  };
};

export default connect(
  state => ({
    video_header_state: state.video_state.header_style
  }),
  dispatch => ({})
)(MobileGridItem);



// WEBPACK FOOTER //
// ./src/pages/home/mobile-grid/MobileGridItem.js